'use client'

import { useEffect } from 'react'

import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import {
  orderEmailClickEvent,
  OrderEmailClickTarget,
} from '@marketplace-web/order-emails/order-emails-tracking-data'

const faqEntryIdToTargetMap: Record<number, OrderEmailClickTarget> = {
  1334: 'factory_reset',
  65: 'how_to_pack_and_ship',
  1361: 'electronic_verification_service',
}

type Props = { faqEntryId: number | null }

const HelpCenterFaqEntryEmailTrackingEvent = ({ faqEntryId }: Props) => {
  const { transaction_id, ch } = useBrowserNavigation().searchParams

  const { track } = useTracking()

  useEffect(() => {
    if (ch !== 'email') return
    if (!faqEntryId) return
    if (!transaction_id || typeof transaction_id !== 'string') return

    const target = faqEntryIdToTargetMap[faqEntryId]

    if (!target) return

    track(
      orderEmailClickEvent({
        transactionId: transaction_id,
        target,
      }),
    )
  }, [faqEntryId, transaction_id, ch, track])

  return null
}

export default HelpCenterFaqEntryEmailTrackingEvent
